// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import * as MyWordsIcons$LiteracyplanetClientSxEntry from "../my_words/MyWordsIcons.res.mjs";

var editColor = Css.hex("0c9ce5");

var layoutFonts = {
  hd: {
    NAME: "custom",
    VAL: "museo-sans-rounded"
  },
  tl: {
    hd: {
      NAME: "custom",
      VAL: "sans-serif"
    },
    tl: /* [] */0
  }
};

var newListColor = Css.hex("089de5");

var listItemColor = Css.hex("fcf1dc");

var mainColor = Css.hex("fbe9c4");

var scrollBackgroundColor = Css.hex("CCDBCD");

var scrollBarColor = Css.hex("009ae8");

var listTitleColor = Css.hex("3b4c90");

var primaryHoverColor = Css.hex("3375b0");

var primaryBlueColor = Css.hex("0c9ce5");

var activityInnerItemColor = Css.hex("fdf9f0");

var buttonTextColor = Css.hex("FFFFFF");

var redProgressColor = Css.hex("ff7266");

var orangeProgressColor = Css.hex("ffc759");

var greenProgressColor = Css.hex("6ede71");

var goldColor = Css.hex("f3c527");

var silverColor = Css.hex("aca8a0");

var bronzeColor = Css.hex("a17711");

var rows = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 117
      },
      tl: {
        hd: {
          NAME: "css",
          VAL: {
            NAME: "fr",
            VAL: 1.0
          }
        },
        tl: /* [] */0
      }
    });

var cols = Theme$LiteracyplanetClientFlags.resizeGridCols({
      hd: {
        NAME: "css",
        VAL: {
          NAME: "fr",
          VAL: 1.0
        }
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 1024
        },
        tl: {
          hd: {
            NAME: "css",
            VAL: {
              NAME: "fr",
              VAL: 1.0
            }
          },
          tl: /* [] */0
        }
      }
    });

var css = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.height({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.display(Css.grid),
          tl: {
            hd: Css.gridTemplateAreas({
                  NAME: "areas",
                  VAL: [
                    "headerLeft headerMiddle headerRight",
                    "folderLeft folder folderRight"
                  ]
                }),
            tl: /* [] */0
          }
        }
      }
    });

var className = Curry._1(Css.merge, {
      hd: css,
      tl: {
        hd: rows,
        tl: {
          hd: cols,
          tl: {
            hd: "Layout",
            tl: /* [] */0
          }
        }
      }
    });

function AcademyComponents$Layout(props) {
  return React.createElement("div", {
              className: className
            }, props.children);
}

var Layout = {
  rows: rows,
  cols: cols,
  css: css,
  className: className,
  make: AcademyComponents$Layout
};

var rows$1 = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 99
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 568
        },
        tl: /* [] */0
      }
    });

var cols$1 = Theme$LiteracyplanetClientFlags.resizeGridCols({
      hd: {
        NAME: "css",
        VAL: {
          NAME: "fr",
          VAL: 1.0
        }
      },
      tl: /* [] */0
    });

var r = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        667
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.borderRadius,
          40
        ],
        tl: /* [] */0
      }
    });

var css$1 = Curry._1(Css.style, {
      hd: Css.gridArea({
            NAME: "ident",
            VAL: "folder"
          }),
      tl: {
        hd: Css.display(Css.grid),
        tl: {
          hd: Css.gridTemplateAreas({
                NAME: "areas",
                VAL: [
                  "activityHeader",
                  "activityContent"
                ]
              }),
          tl: {
            hd: Css.width({
                  NAME: "percent",
                  VAL: 100.0
                }),
            tl: {
              hd: Css.overflow("hidden"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$1 = Curry._1(Css.merge, {
      hd: css$1,
      tl: {
        hd: r,
        tl: {
          hd: rows$1,
          tl: {
            hd: cols$1,
            tl: {
              hd: "Content",
              tl: /* [] */0
            }
          }
        }
      }
    });

function AcademyComponents$Content(props) {
  return React.createElement("div", {
              className: className$1
            }, props.children);
}

var Content = {
  rows: rows$1,
  cols: cols$1,
  r: r,
  css: css$1,
  className: className$1,
  make: AcademyComponents$Content
};

var customScrollStyle = Curry._1(Css.style, {
      hd: Css.selector("::-webkit-scrollbar", Belt_List.concat({
                hd: Css.marginRight({
                      NAME: "px",
                      VAL: 10
                    }),
                tl: /* [] */0
              }, Theme$LiteracyplanetClientFlags.resizeList({
                    hd: [
                      Css.width,
                      25
                    ],
                    tl: {
                      hd: [
                        Css.height,
                        515
                      ],
                      tl: /* [] */0
                    }
                  }))),
      tl: {
        hd: Css.selector("::-webkit-scrollbar-track", Belt_List.concat({
                  hd: Css.backgroundColor(scrollBackgroundColor),
                  tl: /* [] */0
                }, Theme$LiteracyplanetClientFlags.resizeList({
                      hd: [
                        Theme$LiteracyplanetClientFlags.borderRadius,
                        15
                      ],
                      tl: /* [] */0
                    }))),
        tl: {
          hd: Css.selector("::-webkit-scrollbar-thumb", Belt_List.concat({
                    hd: Css.backgroundColor(scrollBarColor),
                    tl: /* [] */0
                  }, Theme$LiteracyplanetClientFlags.resizeList({
                        hd: [
                          Theme$LiteracyplanetClientFlags.borderRadius,
                          15
                        ],
                        tl: /* [] */0
                      }))),
          tl: {
            hd: Css.selector("::-webkit-scrollbar-corner", {
                  hd: Css.background(Css.transparent),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var css$2 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.gridTemplateAreas({
              NAME: "areas",
              VAL: [
                "headerTitle",
                "headerTabs"
              ]
            }),
        tl: {
          hd: Css.gridTemplateRows({
                hd: Css.fr(2.0),
                tl: {
                  hd: Css.fr(1.0),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: Css.gridTemplateColumns({
                  hd: Css.fr(1.0),
                  tl: /* [] */0
                }),
            tl: {
              hd: Css.width({
                    NAME: "percent",
                    VAL: 100.0
                  }),
              tl: {
                hd: Css.height({
                      NAME: "percent",
                      VAL: 100.0
                    }),
                tl: {
                  hd: Css.gridArea({
                        NAME: "ident",
                        VAL: "activityHeader"
                      }),
                  tl: {
                    hd: Css.backgroundColor(listItemColor),
                    tl: {
                      hd: Css.boxSizing(Css.borderBox),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$2 = Curry._1(Css.merge, {
      hd: css$2,
      tl: {
        hd: "Header",
        tl: /* [] */0
      }
    });

function AcademyComponents$Header(props) {
  return React.createElement("div", {
              className: className$2
            }, props.children);
}

var Header = {
  css: css$2,
  className: className$2,
  make: AcademyComponents$Header
};

var r$1 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.fontSize,
        25
      ],
      tl: {
        hd: [
          Css.marginTop,
          29
        ],
        tl: /* [] */0
      }
    });

var css$3 = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.gridArea({
              NAME: "ident",
              VAL: "headerTitle"
            }),
        tl: {
          hd: Css.textAlign("center"),
          tl: {
            hd: Css.fontWeight(Css.bold),
            tl: /* [] */0
          }
        }
      }
    });

var className$3 = Curry._1(Css.merge, {
      hd: r$1,
      tl: {
        hd: css$3,
        tl: {
          hd: "Title",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$Title(props) {
  return React.createElement("div", {
              className: className$3
            }, props.children);
}

var Title = {
  r: r$1,
  css: css$3,
  className: className$3,
  make: AcademyComponents$Title
};

var r$2 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.gridColumnGap,
        10
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.padding,
          10
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.paddingBottom,
            24
          ],
          tl: /* [] */0
        }
      }
    });

var css$4 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.gridArea({
                  NAME: "ident",
                  VAL: "activityContent"
                }),
            tl: {
              hd: Css.backgroundColor(mainColor),
              tl: {
                hd: Css.display(Css.grid),
                tl: {
                  hd: Css.gridTemplateColumns({
                        hd: Css.fr(1.0),
                        tl: {
                          hd: Css.fr(1.0),
                          tl: {
                            hd: Css.fr(1.0),
                            tl: {
                              hd: Css.fr(1.0),
                              tl: /* [] */0
                            }
                          }
                        }
                      }),
                  tl: {
                    hd: Css.overflowY("auto"),
                    tl: {
                      hd: Css.overflowX("hidden"),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$4 = Curry._1(Css.merge, {
      hd: r$2,
      tl: {
        hd: css$4,
        tl: {
          hd: customScrollStyle,
          tl: {
            hd: "MenuMainBody",
            tl: /* [] */0
          }
        }
      }
    });

function AcademyComponents$MenuMainBody(props) {
  return React.createElement("div", {
              className: className$4
            }, props.children);
}

var MenuMainBody = {
  r: r$2,
  css: css$4,
  className: className$4,
  make: AcademyComponents$MenuMainBody
};

var r$3 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.gridColumnGap,
        30
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.paddingBottom,
          24
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.paddingLeft,
            30
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.paddingRight,
              30
            ],
            tl: /* [] */0
          }
        }
      }
    });

var css$5 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.gridArea({
                  NAME: "ident",
                  VAL: "activityContent"
                }),
            tl: {
              hd: Css.backgroundColor(mainColor),
              tl: {
                hd: Css.display(Css.grid),
                tl: {
                  hd: Css.gridTemplateColumns({
                        hd: Css.fr(1.0),
                        tl: {
                          hd: Css.fr(1.0),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: Css.overflowY("auto"),
                    tl: {
                      hd: Css.overflowX("hidden"),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$5 = Curry._1(Css.merge, {
      hd: r$3,
      tl: {
        hd: css$5,
        tl: {
          hd: customScrollStyle,
          tl: {
            hd: "ActivitiesMainBody",
            tl: /* [] */0
          }
        }
      }
    });

function AcademyComponents$ActivitiesMainBody(props) {
  return React.createElement("div", {
              className: className$5
            }, props.children);
}

var ActivitiesMainBody = {
  r: r$3,
  css: css$5,
  className: className$5,
  make: AcademyComponents$ActivitiesMainBody
};

var r$4 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.margin,
        0
      ],
      tl: {
        hd: [
          Css.gap,
          5
        ],
        tl: /* [] */0
      }
    });

var css$6 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.display("flex"),
          tl: {
            hd: Css.flexDirection(Css.column),
            tl: /* [] */0
          }
        }
      }
    });

var className$6 = Curry._1(Css.merge, {
      hd: r$4,
      tl: {
        hd: css$6,
        tl: {
          hd: "MenuNavContainer",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$MenuNavContainer(props) {
  return React.createElement("div", {
              className: className$6
            }, props.children);
}

var MenuNavContainer = {
  r: r$4,
  css: css$6,
  className: className$6,
  make: AcademyComponents$MenuNavContainer
};

var r$5 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.borderRadius,
        25
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.fontSize,
          16
        ],
        tl: {
          hd: [
            Css.height,
            45
          ],
          tl: /* [] */0
        }
      }
    });

var css$7 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.backgroundColor(listItemColor),
          tl: {
            hd: Css.color(listTitleColor),
            tl: {
              hd: Css.fontWeight(Css.bold),
              tl: {
                hd: Css.display(Css.grid),
                tl: {
                  hd: Css.justifyContent(Css.center),
                  tl: {
                    hd: Css.alignContent(Css.center),
                    tl: {
                      hd: Css.hover({
                            hd: Css.color(primaryHoverColor),
                            tl: {
                              hd: Css.border({
                                    NAME: "px",
                                    VAL: 1
                                  }, "solid", primaryBlueColor),
                              tl: {
                                hd: Css.cursor(Css.pointer),
                                tl: /* [] */0
                              }
                            }
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$7 = Curry._1(Css.merge, {
      hd: r$5,
      tl: {
        hd: css$7,
        tl: {
          hd: "MenuNavButton",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$MenuNavButton(props) {
  return React.createElement("div", {
              className: className$7,
              onClick: props.onClick
            }, props.children);
}

var MenuNavButton = {
  r: r$5,
  css: css$7,
  className: className$7,
  make: AcademyComponents$MenuNavButton
};

var r$6 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.margin,
        0
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.paddingRight,
          10
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.paddingTop,
            24
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.gridRowGap,
              20
            ],
            tl: /* [] */0
          }
        }
      }
    });

var css$8 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.display(Css.grid),
        tl: /* [] */0
      }
    });

var className$8 = Curry._1(Css.merge, {
      hd: r$6,
      tl: {
        hd: css$8,
        tl: {
          hd: "ActivitiesContainer",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivitiesContainer(props) {
  return React.createElement("div", {
              className: className$8
            }, props.children);
}

var ActivitiesContainer = {
  r: r$6,
  css: css$8,
  className: className$8,
  make: AcademyComponents$ActivitiesContainer
};

var rows$2 = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 20
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 64
        },
        tl: /* [] */0
      }
    });

var cols$2 = Theme$LiteracyplanetClientFlags.resizeGridCols({
      hd: {
        NAME: "ratio",
        VAL: 105
      },
      tl: {
        hd: {
          NAME: "css",
          VAL: {
            NAME: "fr",
            VAL: 1.0
          }
        },
        tl: {
          hd: {
            NAME: "css",
            VAL: {
              NAME: "fr",
              VAL: 1.0
            }
          },
          tl: /* [] */0
        }
      }
    });

var r$7 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        105
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.borderRadius,
          30
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.borderWidth,
            10
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.gridRowGap,
              21
            ],
            tl: {
              hd: [
                Css.gridColumnGap,
                10
              ],
              tl: {
                hd: [
                  Theme$LiteracyplanetClientFlags.paddingLeft,
                  29
                ],
                tl: {
                  hd: [
                    Theme$LiteracyplanetClientFlags.paddingRight,
                    26
                  ],
                  tl: {
                    hd: [
                      Theme$LiteracyplanetClientFlags.paddingTop,
                      25
                    ],
                    tl: {
                      hd: [
                        Theme$LiteracyplanetClientFlags.paddingBottom,
                        20
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var css$9 = Curry._1(Css.style, {
      hd: Css.boxSizing("contentBox"),
      tl: {
        hd: Css.borderStyle(Css.none),
        tl: {
          hd: Css.display(Css.grid),
          tl: {
            hd: Css.gridTemplateAreas({
                  NAME: "areas",
                  VAL: [
                    "icon title title",
                    "icon play percentage"
                  ]
                }),
            tl: {
              hd: Css.backgroundColor(listItemColor),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$9 = Curry._1(Css.merge, {
      hd: r$7,
      tl: {
        hd: css$9,
        tl: {
          hd: rows$2,
          tl: {
            hd: cols$2,
            tl: {
              hd: "ActivityItem",
              tl: /* [] */0
            }
          }
        }
      }
    });

function AcademyComponents$ActivityItem(props) {
  return React.createElement("div", {
              className: className$9
            }, props.children);
}

var ActivityItem = {
  rows: rows$2,
  cols: cols$2,
  r: r$7,
  css: css$9,
  className: className$9,
  make: AcademyComponents$ActivityItem
};

var r$8 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        104
      ],
      tl: /* [] */0
    });

var className$10 = Curry._1(Css.merge, {
      hd: r$8,
      tl: {
        hd: "ProgressIconImage",
        tl: /* [] */0
      }
    });

function AcademyComponents$ProgressIconImage(props) {
  return React.createElement(MyWordsIcons$LiteracyplanetClientSxEntry.ProgressImageIcon.make, {
              imageUrl: MyWordsIcons$LiteracyplanetClientSxEntry.iconOfKind(props.icon),
              className: className$10,
              progressState: props.progressState
            });
}

var ProgressIconImage = {
  r: r$8,
  className: className$10,
  make: AcademyComponents$ProgressIconImage
};

var r$9 = Curry._1(Css.style, {
      hd: Theme$LiteracyplanetClientFlags.borderRadius({
            NAME: "vw",
            VAL: 10.0
          }),
      tl: {
        hd: Css.background(activityInnerItemColor),
        tl: /* [] */0
      }
    });

var className$11 = Curry._1(Css.merge, {
      hd: className$10,
      tl: {
        hd: r$9,
        tl: {
          hd: "ProgressIconImageLoading",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ProgressIconImageLoading(props) {
  return React.createElement("div", {
              className: className$11
            });
}

var ProgressIconImageLoading = {
  r: r$9,
  className: className$11,
  make: AcademyComponents$ProgressIconImageLoading
};

var r$10 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.fontSize,
        18
      ],
      tl: /* [] */0
    });

var css$10 = Curry._1(Css.style, {
      hd: Css.color(listTitleColor),
      tl: {
        hd: Css.fontWeight("bold"),
        tl: {
          hd: Css.gridArea({
                NAME: "ident",
                VAL: "title"
              }),
          tl: /* [] */0
        }
      }
    });

var className$12 = Curry._1(Css.merge, {
      hd: r$10,
      tl: {
        hd: css$10,
        tl: {
          hd: "ActivityItemTitle",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivityItemTitle(props) {
  return React.createElement("div", {
              className: className$12
            }, props.children);
}

var ActivityItemTitle = {
  r: r$10,
  css: css$10,
  className: className$12,
  make: AcademyComponents$ActivityItemTitle
};

function AcademyComponents$ActivityItemComponent(props) {
  return React.createElement(AcademyComponents$ActivityItem, {
              children: null
            }, props.children, React.createElement(AcademyComponents$ActivityItemTitle, {
                  children: props.name
                }));
}

var ActivityItemComponent = {
  make: AcademyComponents$ActivityItemComponent
};

var r$11 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        60
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.borderRadius,
          15
        ],
        tl: /* [] */0
      }
    });

var css$11 = Curry._1(Css.style, {
      hd: Css.display("grid"),
      tl: {
        hd: Css.gridArea({
              NAME: "ident",
              VAL: "play"
            }),
        tl: {
          hd: Css.width({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.backgroundColor(activityInnerItemColor),
            tl: {
              hd: Css.justifyContent("center"),
              tl: {
                hd: Css.alignItems(Css.center),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var className$13 = Curry._1(Css.merge, {
      hd: r$11,
      tl: {
        hd: css$11,
        tl: {
          hd: "ActivityPlay",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivityPlay(props) {
  return React.createElement("div", {
              className: className$13
            }, props.children);
}

var ActivityPlay = {
  r: r$11,
  css: css$11,
  className: className$13,
  make: AcademyComponents$ActivityPlay
};

var css$12 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: {
        hd: Css.backgroundColor(newListColor),
        tl: {
          hd: Css.hover({
                hd: Css.backgroundColor(primaryHoverColor),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: Css.fontStyle(Css.normal),
            tl: {
              hd: Css.fontWeight({
                    NAME: "num",
                    VAL: 500
                  }),
              tl: {
                hd: Css.fontFamilies(layoutFonts),
                tl: {
                  hd: Css.color(buttonTextColor),
                  tl: {
                    hd: Css.outlineWidth(Css.zero),
                    tl: {
                      hd: Css.borderWidth(Css.zero),
                      tl: {
                        hd: Css.textAlign(Css.center),
                        tl: {
                          hd: Css.display(Css.grid),
                          tl: {
                            hd: Css.justifyItems(Css.center),
                            tl: {
                              hd: Css.alignItems(Css.center),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var r$12 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        44
      ],
      tl: {
        hd: [
          Css.width,
          132
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.fontSize,
            18
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.borderRadius,
              22
            ],
            tl: /* [] */0
          }
        }
      }
    });

var className$14 = Curry._1(Css.merge, {
      hd: r$12,
      tl: {
        hd: css$12,
        tl: {
          hd: "PillButton",
          tl: /* [] */0
        }
      }
    });

var PillButton = {
  css: css$12,
  r: r$12,
  className: className$14
};

var css$13 = Curry._1(Css.style, {
      hd: Css.borderStyle(Css.solid),
      tl: {
        hd: Css.borderColor(buttonTextColor),
        tl: /* [] */0
      }
    });

var r$13 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        40
      ],
      tl: {
        hd: [
          Css.width,
          40
        ],
        tl: /* [] */0
      }
    });

var className$15 = Curry._1(Css.merge, {
      hd: className$14,
      tl: {
        hd: r$13,
        tl: {
          hd: css$13,
          tl: {
            hd: "PrimaryNavButton",
            tl: /* [] */0
          }
        }
      }
    });

var PrimaryNavButton = {
  css: css$13,
  r: r$13,
  className: className$15
};

var r$14 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.borderWidth,
        5
      ],
      tl: {
        hd: [
          Css.width,
          50
        ],
        tl: {
          hd: [
            Css.height,
            50
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.borderRadius,
              25
            ],
            tl: /* [] */0
          }
        }
      }
    });

var css$14 = Curry._1(Css.style, {
      hd: Css.boxSizing(Css.borderBox),
      tl: /* [] */0
    });

var className$16 = Curry._1(Css.merge, {
      hd: className$15,
      tl: {
        hd: r$14,
        tl: {
          hd: css$14,
          tl: {
            hd: "ActivityPlayPrimaryNavButton",
            tl: /* [] */0
          }
        }
      }
    });

function AcademyComponents$ActivityPlayPrimaryNavButton(props) {
  return React.createElement("div", {
              className: className$16,
              onClick: props.onClick
            }, props.children);
}

var ActivityPlayPrimaryNavButton = {
  r: r$14,
  css: css$14,
  className: className$16,
  make: AcademyComponents$ActivityPlayPrimaryNavButton
};

var css$15 = Curry._1(Css.style, {
      hd: Css.height(Css.pct(100.0)),
      tl: /* [] */0
    });

var className$17 = Curry._1(Css.merge, {
      hd: css$15,
      tl: {
        hd: "WordListPlayIcon",
        tl: /* [] */0
      }
    });

function AcademyComponents$WordListPlayIcon(props) {
  return React.createElement(MyWordsIcons$LiteracyplanetClientSxEntry.WordListPlayIcon.make, {
              className: className$17
            });
}

var WordListPlayIcon = {
  css: css$15,
  className: className$17,
  make: AcademyComponents$WordListPlayIcon
};

function AcademyComponents$ActivityPlayButton(props) {
  return React.createElement(AcademyComponents$ActivityPlayPrimaryNavButton, {
              onClick: props.onClick,
              children: React.createElement(AcademyComponents$WordListPlayIcon, {})
            });
}

var ActivityPlayButton = {
  make: AcademyComponents$ActivityPlayButton
};

var r$15 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.height,
        60
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.borderRadius,
          15
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.paddingTop,
            13
          ],
          tl: {
            hd: [
              Theme$LiteracyplanetClientFlags.paddingBottom,
              15
            ],
            tl: {
              hd: [
                Theme$LiteracyplanetClientFlags.paddingLeft,
                15
              ],
              tl: {
                hd: [
                  Theme$LiteracyplanetClientFlags.paddingRight,
                  18
                ],
                tl: {
                  hd: [
                    Css.columnGap,
                    9
                  ],
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var css$16 = Curry._1(Css.style, {
      hd: Css.display("grid"),
      tl: {
        hd: Css.gridAutoFlow("column"),
        tl: {
          hd: Css.gridArea({
                NAME: "ident",
                VAL: "percentage"
              }),
          tl: {
            hd: Css.backgroundColor(activityInnerItemColor),
            tl: {
              hd: Css.justifyContent("center"),
              tl: {
                hd: Css.alignItems("center"),
                tl: {
                  hd: Css.boxSizing(Css.borderBox),
                  tl: {
                    hd: Css.width(Css.pct(100.0)),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var className$18 = Curry._1(Css.merge, {
      hd: r$15,
      tl: {
        hd: css$16,
        tl: {
          hd: "ActivityPercentage",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivityPercentage(props) {
  return React.createElement("div", {
              className: className$18
            }, props.children);
}

var ActivityPercentage = {
  r: r$15,
  css: css$16,
  className: className$18,
  make: AcademyComponents$ActivityPercentage
};

var css$17 = Curry._1(Css.style, {
      hd: Css.color(goldColor),
      tl: /* [] */0
    });

var r$16 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        32
      ],
      tl: {
        hd: [
          Css.height,
          32
        ],
        tl: /* [] */0
      }
    });

var className$19 = Curry._1(Css.merge, {
      hd: css$17,
      tl: {
        hd: r$16,
        tl: {
          hd: "GoldTrophy",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$GoldTrophy(props) {
  return React.createElement(MyWordsIcons$LiteracyplanetClientSxEntry.TrophyIcon.make, {
              className: className$19
            });
}

var GoldTrophy = {
  css: css$17,
  r: r$16,
  className: className$19,
  make: AcademyComponents$GoldTrophy
};

var css$18 = Curry._1(Css.style, {
      hd: Css.color(silverColor),
      tl: /* [] */0
    });

var className$20 = Curry._1(Css.merge, {
      hd: className$19,
      tl: {
        hd: css$18,
        tl: {
          hd: "SilverTrophy",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$SilverTrophy(props) {
  return React.createElement(MyWordsIcons$LiteracyplanetClientSxEntry.TrophyIcon.make, {
              className: className$20
            });
}

var SilverTrophy = {
  css: css$18,
  className: className$20,
  make: AcademyComponents$SilverTrophy
};

var css$19 = Curry._1(Css.style, {
      hd: Css.color(bronzeColor),
      tl: /* [] */0
    });

var className$21 = Curry._1(Css.merge, {
      hd: className$19,
      tl: {
        hd: css$19,
        tl: {
          hd: "BronzeTrophy",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$BronzeTrophy(props) {
  return React.createElement(MyWordsIcons$LiteracyplanetClientSxEntry.TrophyIcon.make, {
              className: className$21
            });
}

var BronzeTrophy = {
  css: css$19,
  className: className$21,
  make: AcademyComponents$BronzeTrophy
};

var r$17 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        15
      ],
      tl: {
        hd: [
          Css.height,
          15
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.borderRadius,
            8
          ],
          tl: /* [] */0
        }
      }
    });

var css$20 = Curry._1(Css.style, {
      hd: Css.backgroundColor(redProgressColor),
      tl: /* [] */0
    });

var className$22 = Curry._1(Css.merge, {
      hd: r$17,
      tl: {
        hd: css$20,
        tl: {
          hd: "RedProgressCircle",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$RedProgressCircle(props) {
  return React.createElement("div", {
              className: className$22
            });
}

var RedProgressCircle = {
  r: r$17,
  css: css$20,
  className: className$22,
  make: AcademyComponents$RedProgressCircle
};

var css$21 = Curry._1(Css.style, {
      hd: Css.backgroundColor(orangeProgressColor),
      tl: /* [] */0
    });

var className$23 = Curry._1(Css.merge, {
      hd: className$22,
      tl: {
        hd: css$21,
        tl: {
          hd: "OrangeProgressCircle",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$OrangeProgressCircle(props) {
  return React.createElement("div", {
              className: className$23
            });
}

var OrangeProgressCircle = {
  css: css$21,
  className: className$23,
  make: AcademyComponents$OrangeProgressCircle
};

var css$22 = Curry._1(Css.style, {
      hd: Css.backgroundColor(greenProgressColor),
      tl: /* [] */0
    });

var className$24 = Curry._1(Css.merge, {
      hd: className$22,
      tl: {
        hd: css$22,
        tl: {
          hd: "GreenProgressCircle",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$GreenProgressCircle(props) {
  return React.createElement("div", {
              className: className$24
            });
}

var GreenProgressCircle = {
  css: css$22,
  className: className$24,
  make: AcademyComponents$GreenProgressCircle
};

var r$18 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.fontSize,
        19
      ],
      tl: {
        hd: [
          Css.margin,
          0
        ],
        tl: /* [] */0
      }
    });

var css$23 = Curry._1(Css.style, {
      hd: Css.fontWeight("bold"),
      tl: /* [] */0
    });

var className$25 = Curry._1(Css.merge, {
      hd: r$18,
      tl: {
        hd: css$23,
        tl: {
          hd: "PercentageText",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$PercentageText(props) {
  return React.createElement("div", {
              className: className$25
            }, props.children);
}

var PercentageText = {
  r: r$18,
  css: css$23,
  className: className$25,
  make: AcademyComponents$PercentageText
};

var r$19 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Theme$LiteracyplanetClientFlags.fontSize,
        14
      ],
      tl: {
        hd: [
          Theme$LiteracyplanetClientFlags.paddingBottom,
          5
        ],
        tl: /* [] */0
      }
    });

var css$24 = Curry._1(Css.style, {
      hd: Css.color(editColor),
      tl: {
        hd: Css.fontWeight("bold"),
        tl: {
          hd: Css.textTransform("uppercase"),
          tl: /* [] */0
        }
      }
    });

var className$26 = Curry._1(Css.merge, {
      hd: r$19,
      tl: {
        hd: css$24,
        tl: {
          hd: "ActivityHeaderTab",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivityHeaderTab(props) {
  return React.createElement("div", {
              className: className$26,
              onClick: props.onClick
            }, props.children);
}

var ActivityHeaderTab = {
  r: r$19,
  css: css$24,
  className: className$26,
  make: AcademyComponents$ActivityHeaderTab
};

var css$25 = Curry._1(Css.style, {
      hd: Css.borderBottom(Css.px(5), "solid", editColor),
      tl: /* [] */0
    });

var className$27 = Curry._1(Css.merge, {
      hd: className$26,
      tl: {
        hd: css$25,
        tl: {
          hd: "SelectedActivityHeaderTab",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$SelectedActivityHeaderTab(props) {
  return React.createElement("div", {
              className: className$27,
              onClick: props.onClick
            }, props.children);
}

var SelectedActivityHeaderTab = {
  css: css$25,
  className: className$27,
  make: AcademyComponents$SelectedActivityHeaderTab
};

function AcademyComponents$ActivityHeaderTabItem(props) {
  var children = props.children;
  var onClick = props.onClick;
  if (props.selected) {
    return React.createElement(AcademyComponents$SelectedActivityHeaderTab, {
                onClick: onClick,
                children: children
              });
  } else {
    return React.createElement(AcademyComponents$ActivityHeaderTab, {
                onClick: onClick,
                children: children
              });
  }
}

var ActivityHeaderTabItem = {
  make: AcademyComponents$ActivityHeaderTabItem
};

var r$20 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.gridColumnGap,
        52
      ],
      tl: /* [] */0
    });

var css$26 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.color(editColor),
        tl: {
          hd: Css.width({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.height({
                  NAME: "percent",
                  VAL: 100.0
                }),
            tl: {
              hd: Css.alignContent("end_"),
              tl: {
                hd: Css.gridArea({
                      NAME: "ident",
                      VAL: "headerTabs"
                    }),
                tl: {
                  hd: Css.gridAutoFlow("column"),
                  tl: {
                    hd: Css.justifyContent("center"),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var className$28 = Curry._1(Css.merge, {
      hd: r$20,
      tl: {
        hd: css$26,
        tl: {
          hd: "ActivityHeaderTabs",
          tl: /* [] */0
        }
      }
    });

function AcademyComponents$ActivityHeaderTabsContainer(props) {
  return React.createElement("div", {
              className: className$28
            }, props.children);
}

var ActivityHeaderTabsContainer = {
  r: r$20,
  css: css$26,
  className: className$28,
  make: AcademyComponents$ActivityHeaderTabsContainer
};

function AcademyComponents$ActivityHeaderTabs(props) {
  var onNavSubCategory = props.onNavSubCategory;
  return React.createElement(AcademyComponents$ActivityHeaderTabsContainer, {
              children: Belt_Array.map(props.strands, (function (strand) {
                      return React.createElement(AcademyComponents$ActivityHeaderTabItem, {
                                  onClick: (function (param) {
                                      Curry._1(onNavSubCategory, strand.id);
                                    }),
                                  selected: false,
                                  children: strand.title
                                });
                    }))
            });
}

var ActivityHeaderTabs = {
  make: AcademyComponents$ActivityHeaderTabs
};

var ratio = Theme$LiteracyplanetClientFlags.resize;

var resizeGridCols = Theme$LiteracyplanetClientFlags.resizeGridCols;

var resizeGridRows = Theme$LiteracyplanetClientFlags.resizeGridRows;

export {
  ratio ,
  editColor ,
  layoutFonts ,
  resizeGridCols ,
  resizeGridRows ,
  newListColor ,
  listItemColor ,
  mainColor ,
  scrollBackgroundColor ,
  scrollBarColor ,
  listTitleColor ,
  primaryHoverColor ,
  primaryBlueColor ,
  activityInnerItemColor ,
  buttonTextColor ,
  redProgressColor ,
  orangeProgressColor ,
  greenProgressColor ,
  goldColor ,
  silverColor ,
  bronzeColor ,
  Layout ,
  Content ,
  customScrollStyle ,
  Header ,
  Title ,
  MenuMainBody ,
  ActivitiesMainBody ,
  MenuNavContainer ,
  MenuNavButton ,
  ActivitiesContainer ,
  ActivityItem ,
  ProgressIconImage ,
  ProgressIconImageLoading ,
  ActivityItemTitle ,
  ActivityItemComponent ,
  ActivityPlay ,
  PillButton ,
  PrimaryNavButton ,
  ActivityPlayPrimaryNavButton ,
  WordListPlayIcon ,
  ActivityPlayButton ,
  ActivityPercentage ,
  GoldTrophy ,
  SilverTrophy ,
  BronzeTrophy ,
  RedProgressCircle ,
  OrangeProgressCircle ,
  GreenProgressCircle ,
  PercentageText ,
  ActivityHeaderTab ,
  SelectedActivityHeaderTab ,
  ActivityHeaderTabItem ,
  ActivityHeaderTabsContainer ,
  ActivityHeaderTabs ,
}
/* editColor Not a pure module */
